import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import useStyles from "./styles";

interface IProps {
  courseType: racehorse360.CourseSurface;
  scheduledCourseType?: racehorse360.CourseSurface;
  className?: string;
}

const CourseTypeSymbol = (props: IProps) => {
  const { courseType, scheduledCourseType, className } = props;

  const classes = useStyles();

  if (courseType === racehorse360.CourseSurface.COURSE_SURFACE_TURF) {
    return (
      <span className={clsx(className, classes.circleBorder)}>
        <span>T</span>
      </span>
    );
  } else if (
    courseType === racehorse360.CourseSurface.COURSE_SURFACE_INNER_TURF
  ) {
    return (
      <span className={clsx(className, classes.rectBorder)}>
        <span>T</span>
      </span>
    );
  } else if (
    courseType === racehorse360.CourseSurface.COURSE_SURFACE_INNER_TRACK
  ) {
    return (
      <span className={clsx(className, classes.circleBorder)}>
        <span className={classes.dot} />
      </span>
    );
  } else if (
    courseType === racehorse360.CourseSurface.COURSE_SURFACE_DOWNHILL_TURF
  ) {
    return (
      <span className={clsx(className, classes.diamondBorder)}>
        <span>+</span>
      </span>
    );
  } else if (
    scheduledCourseType === racehorse360.CourseSurface.COURSE_SURFACE_TURF
  ) {
    return (
      <span className={clsx(className, classes.circleBorder)}>
        <span>X</span>
      </span>
    );
  } else if (courseType === racehorse360.CourseSurface.COURSE_SURFACE_TIMBER) {
    return (
      <span className={clsx(className, classes.diamondBorder)}>
        <span>B</span>
      </span>
    );
  } else if (courseType === racehorse360.CourseSurface.COURSE_SURFACE_HUNT) {
    return (
      <span className={clsx(className, classes.rectBorder)}>
        <span>H</span>
      </span>
    );
  } else if (
    courseType === racehorse360.CourseSurface.COURSE_SURFACE_STEEPLECHASE
  ) {
    return (
      <span className={clsx(className, classes.diamondBorder)}>
        <span>S</span>
      </span>
    );
  } else if (courseType === racehorse360.CourseSurface.COURSE_SURFACE_HURDLE) {
    return (
      <span className={clsx(className, classes.diamondBorder)}>
        <span>H</span>
      </span>
    );
  } else if (
    [
      racehorse360.CourseSurface.COURSE_SURFACE_DIRT_TRAINING,
      racehorse360.CourseSurface.COURSE_SURFACE_TURF_TRAINING,
      racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRAINING
    ].includes(courseType)
  ) {
    return <span>tr</span>;
  } else if (
    courseType === racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRACK
  ) {
    return (
      <span className={clsx(className, classes.diamondBorder)}>
        <span>A</span>
      </span>
    );
  }
  return <></>;
};

export default CourseTypeSymbol;
